import { Button } from '@mui/material';
import { styled } from '@mui/system';

import Color from '@tool/color';

const DButton = styled(Button)(() => ({
  fontWeight: 400,
  lineHeight: 1.5,
  whiteSpace: 'nowrap',
  color: Color.blackColor(0.85),

  '&.active': {
    fontWeight: 500,
    color: Color.primaryColor(1),
    backgroundColor: Color.primaryColor(0.04),
  },
  '&:hover': {
    fontWeight: 500,
    color: Color.primaryColor(1),
    backgroundColor: Color.primaryColor(0.04),
  },
}));

const EButton = styled(DButton)(() => ({
  marginTop: '5px',
  padding: '10px 20px',

  '&:hover': { color: Color.blackColor(0.85) },
  '&.active': { color: Color.primary },
}));

const SureButton = styled(Button)(() => ({
  width: '80px',
  height: '36px',
  borderRadius: '18px',
  fontSize: '14px',
  lineHeight: 1.5,
  fonWeight: 500,
  color: Color.fff,
}));

const ChooseButton = styled(Button)(() => ({
  padding: '2px 4px 2px 6px',
  marginLeft: '10px',
  marginTop: '10px',
  borderRadius: '5px',
  fontSize: '12px',
  lineHeight: 1.5,
  fontWeight: 500,
  backgroundColor: Color.primaryColor(0.1),

  '& .MuiButton-endIcon': {
    marginLeft: '4px',
    marginRight: 0,
  },
  '&:hover': { backgroundColor: Color.primaryColor(0.15) },
}));

export {
  DButton, EButton, SureButton, ChooseButton,
};
